<template>
  <!-- CRM replica of the client trip-summary sidebar (CheckoutSummary.vue), the
       "Reiseübersicht" box shown to the right of every checkout step. Sample
       prices; the only profile-configurable part is the Anzahlung/Restzahlung
       pair (summary_deposit box). -->
  <div class="summary-preview">
    <h3 class="summary-title" :style="{ color: brandColor }">{{ t('checkout_summary', 'Trip Summary') }}</h3>

    <div class="summary-trip">
      <p class="summary-trip-title">Beispielreise Australien</p>
      <p class="summary-trip-dates">25.09.2026 &mdash; 13.10.2026</p>
    </div>

    <div class="summary-divider"></div>

    <div class="summary-row">
      <span>{{ t('checkout_package_price', 'Package Price') }}</span>
      <span class="summary-amount">2.490,00&nbsp;€</span>
    </div>

    <div class="summary-divider"></div>

    <div class="summary-row summary-row--total">
      <span>{{ t('checkout_total', 'Total') }}</span>
      <span class="summary-amount" :style="{ color: brandColor }">2.490,00&nbsp;€</span>
    </div>

    <template v-if="showDepositRows">
      <div class="summary-row summary-row--sub">
        <span>{{ t('checkout_down_payment', 'Down Payment') }}</span>
        <span class="summary-amount">747,00&nbsp;€</span>
      </div>
      <div class="summary-row summary-row--sub">
        <span>{{ t('checkout_remaining', 'Remaining Balance') }}</span>
        <span class="summary-amount">1.743,00&nbsp;€</span>
      </div>
    </template>
  </div>
</template>

<script>
import previewLang from './previewLang';

export default {
  name: 'OverviewPreview',
  mixins: [previewLang],
  props: {
    lang: { type: String, default: 'de' },
    brandColor: { type: String, default: '#1a73e8' },
    boxVisibility: { type: Object, default: () => ({}) }
  },
  computed: {
    // summary_deposit defaults ON (absent key = shown), unlike the other boxes.
    showDepositRows() {
      const v = this.boxVisibility.summary_deposit;
      return v === undefined || v === true || v === 1;
    }
  }
};
</script>

<style scoped>
.summary-preview {
  max-width: 340px;
  background: #fafafa;
  border: 1px solid #e8e8e8;
  border-radius: 8px;
  padding: 20px;
}

.summary-title { font-size: 16px; font-weight: 700; margin: 0 0 16px; }
.summary-trip-title { font-weight: 600; font-size: 14px; margin: 0 0 4px; }
.summary-trip-dates { font-size: 13px; color: #666; margin: 0; }
.summary-divider { height: 1px; background: #e0e0e0; margin: 14px 0; }

.summary-row {
  display: flex; justify-content: space-between; align-items: center;
  font-size: 13px; margin-bottom: 8px;
}
.summary-row--total { font-weight: 700; font-size: 15px; margin-top: 4px; }
.summary-row--sub { font-size: 12px; color: #666; }
.summary-amount { font-weight: 600; white-space: nowrap; }
</style>
